import React from 'react'
/*
    this class use the react Components to administrate one input type password
*/
interface SettingsTextInputPasswordProps
{
	name: string
	label: string
	value: string
	error: string
	handleChange(event: React.FormEvent<HTMLInputElement>): void
}

interface SettingsTextInputPasswordState
{

}

export default class SettingsTextInputPassword extends React.Component<SettingsTextInputPasswordProps, SettingsTextInputPasswordState> {
	
	constructor(props: SettingsTextInputPasswordProps) {
        super(props);
        this.state = {
        };
    }
	
	render() {
        return (
            <div>
                <div className="row">
                    <label className="col-md-4">
                        {this.props.label}
                    </label>
                    <div className="col-md-8">
                        <input
							name={this.props.name}
                            type={"text"}
                            value={this.props.value}
                            style={{border: this.props.error === "" ? "1px solid #ddd" : "1px solid red"}}
                            onChange={this.props.handleChange}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8 offset-md-4">
                        {this.props.error}
                    </div>
                </div>
            </div>
        );
    }
}